<template>
  <div class="wrapper">
    <CustomTitle class="title" zh="迪哲教育发展历程" en="DEVELOPMENT HISTORY" />
    <div class="timeline">
      <swiper :options="swiperOption" ref="mySwiper" class="timeline-dates">
        <swiper-slide v-for="item of timeline" :key="item.id"
          ><div>
            <h2 class="time">{{ item.time }}</h2>
            <div class="history">{{ item.history }}</div>
          </div></swiper-slide
        >
      </swiper>

      <div class="timeline-button-container">
        <div class="timeline-button-prev" slot="button-prev">
          <img alt="轮播上一张" src="../assets/arrow.svg" />
        </div>
        <div class="timeline-button-circle"></div>
        <div class="timeline-button-next" slot="button-next">
          <img alt="轮播下一张" src="../assets/arrow.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import CustomTitle from "../components/common/CustomTitle";

export default {
  components: {
    swiper,
    swiperSlide,
    CustomTitle
  },
  data() {
    return {
      timeline: [
        {
          time: "2015年5月",
          history: "HKOK香不香港平台正式上线，用户突破5000"
        },
        {
          time: "2015年10月",
          history: "获得香港理工大学专项基金CEF资助，入驻香港科技园孵化"
        },
        {
          time: "2016年7月",
          history: "获得独立投资人天使轮投资200万人民币"
        },
        {
          time: "2017年12月",
          history: "获得香港主板上市公司基金A轮投资千万级人民币"
        },
        {
          time: "2018年2月",
          history: "获得港理工及香港政府ITC匹配基金TLF资助合计100万港币"
        },
        {
          time: "2018年5月",
          history: "LXBIRD留学鸟平台正式上线，用户数破万"
        },
        {
          time: "2018年9月",
          history: "HKOK香不香港平台于香港地区留学生市场占有率超70%"
        },
        {
          time: "2019年3月",
          history: "Woflat小窝公寓独立品牌成立"
        },
        {
          time: "2019年6月",
          history: "大K卡留学生专属电话卡上线，申请用户迅速破3000"
        },
        {
          time: "2019年7月",
          history: "2019上半年营收逾千万港币"
        },
        {
          time: "2021年1月",
          history: "Plus求职独立品牌成立"
        }
      ],
      swiperOption: {
        navigation: {
          nextEl: ".timeline-button-next",
          prevEl: ".timeline-button-prev"
        },
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.swiper.slideTo(2, 0, false);
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  background: #fafafa
    repeating-linear-gradient(
      -45deg,
      rgba(0, 0, 0, 0) 2px,
      rgba(0, 0, 0, 0) 7px,
      #f4f4f4 0px,
      #f4f4f4 8px
    );
}
.title {
  position: absolute;
  top: 45px;
  left: 16%;
}

.timeline {
  min-width: 1279px;

  position: relative;
}
.timeline-dates {
  box-sizing: border-box;
  width: 1279px;

  &.swiper-container:after {
    position: absolute;
    content: "";
    width: 100%;
    top: 50%;
    left: 0;
    height: 1px;
    box-sizing: border-box;
    background-color: #dddddd;
  }

  .swiper-slide {
    height: 412px;
    padding: 0 66px;
    text-align: center;
    color: black;
    cursor: pointer;
    font-weight: bold;
    min-height: 37px;
    width: auto;

    div {
      position: relative;
      font-size: 1rem;
      top: 0;
      line-height: 1;
      padding-top: 230px;
      & .history {
        padding-top: 10px;
        color: #7a7a7a;
        font-size: 14px;
        max-width: 200px;
        line-height: 1.3;
      }
    }

    &-active {
      background-color: white;
      div {
        & .time {
          color: #3a8df5;
        }
        & .history {
          color: #232323;
        }
      }
    }
  }
}

.timeline-button {
  &-container {
    transform: translate(-50%, -50%);
    z-index: 3;
    position: absolute;
    left: 50%;
    top: 50%;
    display: flex;
    & > * {
      margin: 0 10px;
    }
  }
  &-next,
  &-prev {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    & img {
      width: 100%;
    }
  }
  &-prev {
    transform: rotateY(180deg);
  }

  &-circle {
    position: relative;
    height: 21px;
    width: 21px;
    background-color: #3a8df5;
    border-radius: 50%;

    &:before {
      content: " ";
      position: absolute;
      left: 4px;
      top: 4px;
      display: block;
      height: 13px;
      width: 13px;
      background-color: white;
      border-radius: 50%;
    }

    &:after {
      content: " ";
      position: absolute;
      left: 7px;
      top: 7px;
      display: block;
      height: 7px;
      width: 7px;
      background-color: #3a8df5;
      border-radius: 50%;
    }
  }
}
</style>
